import { Environments } from 'src/types/Environments';

export default function getEnvironment(environment: string): Environments {
  let stageEnv: string | undefined = environment;
  if (typeof window === 'undefined') {
    stageEnv = process.env.STAGE;
  }

  switch (stageEnv?.toLowerCase()) {
    case 'gamma':
      return Environments.gamma;
    // for local development on beta
    case '{{stage}}':
    case 'beta':
      return Environments.beta;
    default:
      return Environments.prod;
  }
}
